import { MarketList } from '@market/react';
import { OrderSummaryCartSummary } from 'typescript/types/api/solidshop';
import { CartItem } from 'typescript/apps/checkout_v3/components/order_summary/components/cart_item';
import { sortProductByHardwareOrSoftware } from 'utilities/software';
import { SOFTWARE_BASE_PRODUCT_KEYS } from 'constants/software';

export type CartItemsProps = {
  cartSummary: OrderSummaryCartSummary[];
  isPnpSubscribed?: boolean;
  locationCount?: number;
  kioskDeviceCount?: number;
  k1aDeviceCount?: number;
};

export const CartItems = ({
  cartSummary,
  isPnpSubscribed = false,
  locationCount = 1,
  kioskDeviceCount = 1,
  k1aDeviceCount = 0,
}: CartItemsProps) => {
  const { software: softwareProducts, hardware: hardwareProducts } =
    sortProductByHardwareOrSoftware(cartSummary);

  return (
    <MarketList>
      {[...softwareProducts, ...hardwareProducts].map(
        (cartItem: OrderSummaryCartSummary, index: number) => (
          <CartItem
            key={index}
            label={cartItem.product_variant.title}
            cost={cartItem.amount}
            currency={cartItem.currency}
            imgSrc={cartItem.img}
            quantity={cartItem.quantity}
            serialNumber={cartItem.exchange_serial_number}
            plan={cartItem.plan}
            baseProductKey={cartItem.base_product_key}
            sharedLocationPlan={
              softwareProducts.find(
                (item: OrderSummaryCartSummary) =>
                  item.base_product_key === SOFTWARE_BASE_PRODUCT_KEYS.SW_KIOSK,
              )?.plan
            }
            isSoftware={cartItem.is_software}
            isPnpSubscribed={isPnpSubscribed}
            locationCount={locationCount}
            kioskDeviceCount={kioskDeviceCount}
            k1aDeviceCount={k1aDeviceCount}
          />
        ),
      )}
    </MarketList>
  );
};
